export const importFields = [
  {
    // Visible in table header and when matching columns.
    label: "Status",
    // This is the key used for this field when we call onSubmit.
    key: "status",
    // Allows for better automatic column matching. Optional.
    alternateMatches: ["status"],
    // Used when editing and validating information.
    fieldType: {
      // There are 3 types - "input" / "checkbox" / "select".
      type: "input",
    },
    // Used in the first step to provide an example of what data is expected in this field. Optional.
    example: "Active",
    // Can have multiple validations that are visible in Validation Step table.
    validations: [
      {
        // Can be "required" / "unique" / "regex"
        rule: "required",
        errorMessage: "Status is required",
        // There can be "info" / "warning" / "error" levels. Optional. Default "error".
        level: "error",
      },
    ],
  },
  {
    label: "Role",
    key: "role",
    alternateMatches: ["role"],
    fieldType: {
      type: "input",
    },
    example: "CSR",
    // validations: [
    //   {
    //     rule: "required",
    //     errorMessage: "Last Name is required",
    //     level: "error",
    //   },
    // ],
  },
  {
    label: "Full Name",
    key: "fullName",
    alternateMatches: ["name"],
    fieldType: {
      type: "input",
    },
    example: "Peter Zanetti",
    //   validations: [
    //     {
    //       rule: "required",
    //       errorMessage: "Company is required",
    //       level: "error",
    //     },
    //   ],
  },
  {
    label: "Street",
    key: "street1",
    alternateMatches: ["street1"],
    fieldType: {
      type: "input",
    },
    example: "444 Lake Ave",
    validations: [
      {
        rule: "required",
        errorMessage: "Street is required",
        level: "error",
      },
    ],
  },
  {
    label: "City",
    key: "city",
    alternateMatches: ["city"],
    fieldType: {
      type: "input",
    },
    example: "Boston",
    validations: [
      {
        rule: "required",
        errorMessage: "City is required",
        level: "error",
      },
    ],
  },
  {
    label: "State",
    key: "state",
    alternateMatches: ["state"],
    fieldType: {
      type: "input",
    },
    example: "MA",
    validations: [
      {
        rule: "required",
        errorMessage: "State is required",
        level: "error",
      },
    ],
  },
  {
    label: "Zip Code",
    key: "zipCode",
    alternateMatches: ["zipCode"],
    fieldType: {
      type: "input",
    },
    example: "90210",
    // validations: [
    //   {
    //     rule: "required",
    //     errorMessage: "Zip Code is required",
    //     level: "error",
    //   },
    // ],
  },
  {
    label: "Email",
    key: "email",
    alternateMatches: ["email"],
    fieldType: {
      type: "input",
    },
    example: "petez@example.com",
    // validations: [
    //   {
    //     rule: "required",
    //     errorMessage: "Address is required",
    //     level: "error",
    //   },
    // ],
  },
  {
    label: "Hourly Rate",
    key: "hourlyRate",
    alternateMatches: ["hourly rate"],
    fieldType: {
      type: "input",
    },
    example: "500",
    // validations: [
    //   {
    //     rule: "required",
    //     errorMessage: "Address is required",
    //     level: "error",
    //   },
    // ],
  },
];
